var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cell-container"},_vm._l((_vm.childern),function(i){return _c('div',{key:i.index,staticClass:"cell"},[_c('div',{staticClass:"image-container"},[_c('img',{attrs:{"src":i.image}}),_c('div',{staticClass:"name"},[_vm._v(_vm._s(i.name))])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }